/* eslint-disable prettier/prettier */

const CommandStorage = require('./powerup-command-storage.js');
const util = require('./util.js');

// html for existing rules, scheduled commands, and due date automations
const commandItem = function(command, obo_writable, is_admin) {
  let libsSection;
  libsSection = `
  <div>
    <a class="ui top left label ${obo_writable !== false ? '' : 'unclickable '}command-lib-name"> 
      <i class="tag icon"></i> 
      <span class="text">${util.sanitize(command.lib || '')}</span> 
    </a> 
  </div>
  `;

  // prettier-ignore
  const item = $(
    `<div id="${util.sanitize(command.id)}" class="ui grid transition hidden command">
      <div class="two column paddingless row">
        <div class="flex paddingless column">
          ${libsSection}
          <div class="command-btns">
            ${command.type === 'schedule' && obo_writable !== false
              ? `<div class="ui transparent icon button run-command-btn" 
                  tabindex="0" 
                  alt="Run Now" 
                  data-tooltip="Run Now" 
                >
                  <i class="rocket icon"></i>
                </div>`
              : ''}
            ${obo_writable !== false 
              ? `<div class="ui transparent icon button edit-command-btn${!command.is_own ? ' disabled' : '' }" 
                  tabindex="0" 
                  alt="Edit" 
                  data-tooltip="Edit" 
                >
                  <img class="icon" src="img/edit.svg"></img>
                </div> 
                <div class="ui transparent icon button copy-command-btn" 
                  tabindex="0" 
                  alt="Copy" 
                  data-tooltip="Copy" 
                >
                  <img class="icon" src="img/copy.svg"></img>
                </div> 
                <div class="ui transparent icon button remove-command-btn${command.is_own || is_admin ? '' : ' disabled'}" 
                  tabindex="0" 
                  alt="Remove" 
                  data-tooltip="Remove" 
                >
                  <img class="icon" src="img/trash.svg"></img>
                </div>`
              : ''}
            <div class="ui transparent icon button command-log-btn" 
              tabindex="0" 
              alt="Automation log" 
              data-tooltip="Automation log" 
            >
              <img class="icon" src="img/lightbulb.svg"></img>
            </div>
          </div>
          ${obo_writable !== false
            ? `<div class="ui button add-to-board-btn" 
                tabindex="0" 
                alt="Add to another board"
                data-tooltip="Add to another board"
              >
                <i class="plus icon"></i>
                Add to another board
              </div>`
            : ''} 
        </div>
        <div class="column right aligned modified-by-container">
          <div class="modified-by"></div>
        </div>
      </div>

      <div class="one column paddingless row"> 
        <div class="column code-area">${util.sanitize(command.cmd)}</td> 
      </div>

      <div class="one column paddingless row"> 
        <div class="ui enable-board" data-position="bottom left">
          <div class="ui form">
            <div class="inline fields">
              <div class="field">
                <div class="ui radio checkbox sharing-btns">
                  <input type="radio" name="should-enable-${util.sanitize(command.id)}" id="enable-id-${util.sanitize(command.id)}" data-id="${util.sanitize(command.id)}"
                    class="enable-command-tgl" tabindex="0" class="hidden" ${command.enabled ? ' checked' : '' }>
                  <label class="buttons-label">Enable automation on board</label>
                </div>
              </div>
              <div class="field">
                <div class="ui radio checkbox sharing-btns">
                  <input type="radio" name="should-enable-${util.sanitize(command.id)}" id="disable-id-${util.sanitize(command.id)}" data-id="${util.sanitize(command.id)}"
                    class="disable-command-tgl" tabindex="0" class="hidden" ${!command.enabled ? ' checked' : '' }>
                  <label class="buttons-label">Disable automation on board</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `);

  return item;
};

// html for existing card and board buttons
const buttonItem = function(button, is_admin, is_workspace_guest) {
  // prettier-ignore
  const greenTag = `
  <div class="green-tag">
    <p><b>Anyone in this workspace can enable this button.</b></p>
  </div>
  `
  // prettier-ignore
  const workspaceButton =  `
  <div class="ui form">
    <div class="ui inline fields fields-container">
        <div class="more-options-container">
            <label><b class="more-options-label">More options: </b></label>
            <i class="ui info circle md icon card-board-more-options-info-icon"></i>
        </div>
        <div class="ui basic popup card-board-more-options-popup">
          <div class="ui vertical segment center aligned">
              <p class="ui more-info">More options</p>
              <img class="close-icon close-popup" src="img/close.svg" alt="Close Popup" />
          </div>
          <div class="popup-content">
              <p class="popup-description">
                Showing this button on all Workspace visible boards means it will appear by default for all
                Workspace members on all non-private boards.
                <br><br>
                You can choose who can enable this button on other boards. You will be the only one who can edit or
                delete it.
                <a href="https://support.atlassian.com/trello/docs/creating-and-managing-butler-commands/#Managing-Automations" target="_blank">Learn more</a>
              </p>
          </div>
        </div>
        <div class="checkbox-container">
            <div class="ui checkbox-field checkbox sharing-btns">
                <input type="checkbox" class="scope-command-tgl" ${ button.scope===CommandStorage.ScopeTeam ? ' checked'
                    : '' }>
                <label class="buttons-label">Show on all Workspace visible boards</label>
            </div>
            <div class="ui checkbox-field checkbox sharing-btns workspace-enable-field">
                <input type="checkbox" class="share-command-tgl" ${button.shared ? ' checked' : '' }>
                <label class="buttons-label">Anyone in Workspace can enable this button</label>
            </div>
        </div>
    </div>
  </div>
  `

  // prettier-ignore
  const radioButtons = `
  <div class="ui stackable grid visibility-buttons-container">
    <div class="ui six wide column visibility-radio-buttons">
        <div class="ui form">
            <div class="inline fields">
                <div class="field">
                    <div class="ui radio checkbox sharing-btns">
                        <input type="radio" name="should-enable-${util.sanitize(button.id)}" id="enable-id-${util.sanitize(button.id)}" data-id="${util.sanitize(button.id)}" class="enable-command-tgl" tabindex="0" class="hidden" ${button.enabled ? ' checked' : '' }>
                        <label class="buttons-label">Show on this board</label>
                    </div>
                </div>
                <div class="field">
                    <div class="hidden-on-board-button">
                        <div class="ui radio checkbox sharing-btns">
                            <input type="radio" name="should-enable-${util.sanitize(button.id)}" id="disable-id-${util.sanitize(button.id)}" data-id="${util.sanitize(button.id)}" class="disable-command-tgl" tabindex="0" class="hidden" ${!button.enabled ? ' checked' : '' }>
                            <label class="buttons-label">Hide on this board for you only</label>
                        </div>
                        <i class="ui info circle md icon card-board-hide-button-info-icon"></i>
                        <div class="ui basic popup card-board-hide-button-popup">
                            <div class="ui vertical segment center aligned">
                                <p class="ui more-info">Hide button</p>
                                <img class="close-icon close-popup" src="img/close.svg" alt="Close Popup" />
                            </div>
                            <div class="popup-content">
                              <p class="popup-description">
                                This button will be removed from the board from your view. Other members on this board will still
                                be able to use the button.
                              </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ui ten wide column workspace-checkboxes">
        ${ (!button.is_own || is_workspace_guest) ? greenTag : workspaceButton}
    </div>
  </div>`;

  // prettier-ignore
  const item = $(`<div id="${util.sanitize(button.id)}" class="ui grid transition hidden command">
  <div class="two column paddingless row">
      <div class="flex paddingless column">
          <div class="ui labeled icon limited button">
              <i class="${util.sanitize(button.icon)}"></i>
              ${util.sanitize(button.label || '')}
          </div>
          <div class="command-btns">
              <div class="ui transparent icon button edit-command-btn${!button.is_own ? ' disabled' : ''
  }" tabindex="0" alt="Edit" data-tooltip="Edit">
                  <img class="icon" src="img/edit.svg"></img>
              </div>
              <div class="ui transparent icon button copy-command-btn" tabindex="0" alt="Copy" data-tooltip="Copy">
                  <img class="icon" src="img/copy.svg"></img>
              </div>
              <div class="ui transparent icon button remove-command-btn${button.is_own || is_admin ? '' : ' disabled'
  }" tabindex="0" alt="Remove" data-tooltip="Remove">
                  <img class="icon" src="img/trash.svg"></img>
              </div>
              <div class="ui transparent icon button command-log-btn" tabindex="0" alt="Automation log"
                  data-tooltip="Automation log">
                  <img class="icon" src="img/lightbulb.svg"></img>
              </div>
          </div>
      </div>
      <div class="column right aligned modified-by-container">
          <div class="modified-by"></div>
      </div>
  </div>
  <div class="one column paddingless row">
      <div class="column code-area">${util.sanitize(button.cmd)}</div>
  </div>
  ${radioButtons}
</div>`);
  return item;
};

const actionOutput = function(text) {
  // allows board and list names to be edited in place for actions
  const outputPhraseHtml = text
    .replace(/\\"/g, '__QUOTE__')
    .split('"')
    .map(function(x, i, a) {
      x = util.sanitize(x.replace(/__QUOTE__/g, '"'));
      if (i % 2 === 0) {
        return `<div class="action-output-text">${x}</div>`;
      }
      let style = '';
      // if it's the last piece and it's a quoted-value, add a bit of margin under it
      if (i === a.length - 2) {
        style = `style="margin-bottom: 8px";`;
      }
      if (a[i - 1].slice(-6) === ' list ') {
        return `<div class="ui search"><input class="quoted-value prompt" type="text" name="list-name" value="${x}" placeholder="${x}" ${style}></div>`;
      }
      if (a[i - 1].slice(-6) === ' card ') {
        return `<div class="ui search"><input class="quoted-value prompt" type="text" name="card-title-search" value="${x}" placeholder="${x}" ${style}></div>`;
      }
      if (a[i - 1].slice(-7) === ' board ') {
        return `<div class="ui search"><input class="quoted-value prompt" type="text" name="board-name" value="${x}" placeholder="${x}" ${style}></div>`;
      }
      return `<textarea class="quoted-value" type="text" placeholder="${x}" rows="1" ${style}>${x}</textarea>`;
    })
    .join('');

  const implicitMultiplier = text.match(/^copy each|move each/); // Should do this better.

  // prettier-ignore
  const item = $(`
    <div class="ui grid item${implicitMultiplier ? ' implicit-multiplier' : ''}">
      <div class="paddingless row">
        <div class="thirteen wide column content output-phrase">${outputPhraseHtml}</div>
        <div class="three wide column right floated content output-side right">
          <div class="ui translucent icon button remove-action-btn" 
            tabindex="0"
          >
            <i class="trash icon"></i>
          </div>
          <div class="ui translucent icon button move-up-action-btn${implicitMultiplier ? ' disabled' : ''}"
            tabindex="0"
          >
            <i class="arrow up icon"></i>
          </div>
        </div>
      </div>
    </div>
  `);

  return item;
};

const triggerOutput = function(text) {
  // allows board and list names to be edited in place for triggers
  const outputPhraseHtml = text
    .replace(/\\"/g, '__QUOTE__')
    .split('"')
    .map(function(x, i, a) {
      x = util.sanitize(x.replace(/__QUOTE__/g, '"'));
      if (i % 2 === 0) {
        return `<div class="trigger-output-text">${x}</div>`;
      }
      let style = '';
      // if it's the last piece and it's a quoted-value, add a bit of margin under it
      if (i === a.length - 2) {
        style = `style="margin-bottom: 8px";`;
      }
      if (a[i - 1].slice(-6) === ' list ') {
        return `<div class="ui search"><input class="quoted-value prompt" type="text" name="list-name" value="${x}" placeholder="${x}" ${style}></div>`;
      }
      if (a[i - 1].slice(-7) === ' board ') {
        return `<div class="ui search"><input class="quoted-value prompt" type="text" name="board-name" value="${x}" placeholder="${x}" ${style}></div>`;
      }
      return `<textarea class="quoted-value" type="text" placeholder="${x}" rows="1" ${style}>${x}</textarea>`;
    })
    .join('');
  // prettier-ignore
  const item = $(`
    <div class="ui grid item">
      <div class="thirteen wide column content output-phrase">${outputPhraseHtml}</div>
      <div class="three wide column right floated content output-side right">
        <div class="ui translucent icon button remove-trigger-btn" 
          tabindex="0"
        >
          <i class="trash icon"></i>
        </div>
      </div>
    </div>
  `);

  return item;
};

const Generator = {
  buttonItem,
  commandItem,
  actionOutput,
  triggerOutput,
};

module.exports = Generator;
